import PngTaxCalculator from './png-tax-calculator';
export default function App() {
  return <PngTaxCalculator />;
}
